/**
 * Level 1: Meadow (Tutorial)
 * 
 * Introduction level teaching basic mechanics:
 * - Rolling and jumping
 * - Collecting stars
 * - Pushing boxes to buttons
 * - Trampolines for high jumps
 * 
 * @module configs/levels/Level01_Meadow
 */

/**
 * @typedef {import('../LevelTypes').LevelConfig} LevelConfig
 */

/** @type {LevelConfig} */
const Level01_Meadow = {
    id: 1,
    name: 'Meadow',
    subtitle: 'The Beginning',
    description: 'Learn the basics of rolling, jumping, and magnetic pulling.',

    // World dimensions
    worldWidth: 3200,
    worldHeight: 1000,

    // Player spawn point
    playerStart: { x: 100, y: 700 },

    // Visual theme
    theme: {
        bgGradient: ['#87CEEB', '#98FB98'],
        platformColor: 0x228B22,
        accentColor: 0x90EE90,
        particleColor: 0xffffff
    },

    // Static platforms
    platforms: [
        { x: 0, y: 700, w: 1200, h: 50 },
        { x: 750, y: 500, w: 300, h: 20 },
        { x: 1300, y: 700, w: 1000, h: 50 },
        { x: 1800, y: 550, w: 200, h: 20 },
        { x: 2400, y: 700, w: 800, h: 50 }
    ],

    // Hazards
    spikes: [
        { x: 1500, y: 700 },
        { x: 1550, y: 700 }
    ],

    // Collectibles
    stars: [
        { x: 750, y: 450 },
        { x: 1800, y: 500 },
        { x: 2600, y: 650 }
    ],

    // Enemies
    enemies: [
        { x: 800, y: 650 },
        { x: 1600, y: 650 },
        { x: 2200, y: 650 }
    ],

    // Puzzle elements
    door: { x: 2900, y: 550, w: 50, h: 300 },
    button: { x: 2500, y: 695 },
    box: { x: 600, y: 650, floating: false },
    goal: { x: 3100, y: 600 },

    // Special mechanics
    trampolines: [
        { x: 950, y: 700, w: 80 }
    ],

    // Speedrun targets (in seconds)
    speedrunTargets: { gold: 25, silver: 35, bronze: 50 }
};

export default Level01_Meadow;
